import React from "react";
import PropTypes from "prop-types";
import Button from "material-ui/Button";
import DownloadIcon from "material-ui-icons/FileDownload";
import Menu, { MenuItem } from "material-ui/Menu";
import { connect } from "react-redux";
import "./DownloadAs.css";

class DownloadAs extends React.Component {
  state = {
    anchorEl: null
  };

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({
      anchorEl: null
    });
  };

  handleMenuItemClick(value) {
    switch (value) {
      case "xls":
        this.props.xlsClick();
        break;
      case "pdf":
        this.props.pdfClick();
        break;
      default:
        break;
    }
    this.handleClose();
  }

  render() {
    const { anchorEl } = this.state;
    const { disabled, lang, xls, pdf, size } = this.props;
    const open = Boolean(anchorEl);

    return (
      <React.Fragment>
        <Button
          variant="raised"
          color="primary"
          className="download-as-button"
          disabled={disabled}
          onClick={this.handleClick}
          size={size || "large"}
        >
          {lang.DescargarComo}
          <DownloadIcon />
        </Button>
        <Menu
          value={"none"}
          id="save-as"
          anchorEl={anchorEl}
          open={open}
          onClose={this.handleClose}
        >
          {xls && (
            <MenuItem
              value="xls"
              onClick={this.handleMenuItemClick.bind(this, "xls")}
            >
              XLS
            </MenuItem>
          )}
          {pdf && (
            <MenuItem
              value="xls"
              onClick={this.handleMenuItemClick.bind(this, "pdf")}
            >
              PDF
            </MenuItem>
          )}
        </Menu>
      </React.Fragment>
    );
  }
}

DownloadAs.propTypes = {
  disabled: PropTypes.bool,
  xls: PropTypes.bool,
  xlsClick: PropTypes.func,
  pdf: PropTypes.bool,
  pdfClick: PropTypes.func
};

const mapStateToProps = state => ({
  lang: state.internationalization.lang
});

export default connect(
  mapStateToProps,
  null
)(DownloadAs);



// WEBPACK FOOTER //
// ./src/components/DownloadAs/DownloadAs.js